<template>
    <div class="pl-2 pt-2">
        <v-row>
            <v-col cols="12" sm="6">
                <div class="default_card_wm pt-2" v-if="document.id">
                    <div class="d-flex justify-space-between">
                        <!-- Toolbar DocumentSide -->
                        <div>
                            <v-btn-back
                                @click.stop="back()"
                                v-if="!$vuetify.display.mobile && mode != 'GeneralLedger' && goBackHistory"
                            >
                            </v-btn-back>
                            <v-btn-icon
                                icon="$oss-zoom-out"
                                v-if="!isPDF"
                                :disabled="zoomManager.disableZoomOut()"
                                class="btn mr-1"
                                @click.stop="zoomManager.zoomOut()"
                            />
                            <v-btn-icon
                                icon="$oss-focus"
                                v-if="!isPDF"
                                :disabled="zoomManager.disableResetZoom()"
                                class="btn mx-1"
                                @click.stop="zoomManager.resetZoom()"
                            />
                            <v-btn-icon
                                icon="$oss-zoom-in"
                                v-if="!isPDF"
                                :disabled="zoomManager.disableZoomIn()"
                                class="btn ml-1"
                                @click.stop="zoomManager.zoomIn()"
                            />
                        </div>
                        <div class="d-flex align-center">
                            <template v-if="activeTab === 'document'">
                                <v-btn-icon
                                    icon="$oss-eye"
                                    :disabled="zoomManager.disableResetZoom()"
                                    class="btn ml-1"
                                    :color="showOCR ? 'primary' : 'secondary'"
                                    :loading="ocrLoading"
                                    @click.stop="onOCRChanged()"
                                    v-if="document.signedUrlOCR"
                                    size="small"
                                />
                                <v-text-field-filled
                                    v-model="selectedText"
                                    v-show="selectedText"
                                    id="selectedText"
                                    hide-details
                                    class="ml-2 small-prepend-icon"
                                    append-inner-icon="$oss-close"
                                    block
                                    density="compact"
                                    @click:append-inner="emptySelectedText"
                                />
                            </template>
                            <DocumentDropDown
                                v-bind="{
                                    document,
                                    isIncomingOutgoingPayment,
                                    restartAnalysis,
                                    disabledDelete,
                                }"
                                v-model:showAccountingLines="showAccountingLines"
                                v-model:activeTab="activeTab"
                                v-model:accountingLinesLockedDialog="accountingLinesLockedDialog"
                                v-model:analyseDocumentDialog="analyseDocumentDialog"
                                v-model:deleteDocumentDialog="deleteDocumentDialog"
                            />
                        </div>
                    </div>
                    <div>
                        <v-window v-model="activeTab" class="mt-4">
                            <v-window-item value="document">
                                <DocumentFileViewer
                                    v-bind="{ document }"
                                    :svgVariants="svgVariants"
                                    :showOCR="showOCR"
                                    :ocr="ocr"
                                    @showCorrespondingField="showCorrespondingField"
                                    @token-click="onClickToken"
                                />
                            </v-window-item>
                            <v-window-item value="accountingLines">
                                <AccountingItemStatic
                                    :companyId="companyId"
                                    :documentId="document.id"
                                    :mode="isAccountingItem ? 'AllOption' : 'Embedded'"
                                    ref="accountingItemStatic"
                                    :key="accountingLinesRefreshKey"
                                    @upsert="onAccountingItemUpdated"
                                    v-if="document.id"
                                />
                            </v-window-item>
                            <v-window-item value="activity">
                                <UsersActivitiesHistory :documentId="document.id" />
                            </v-window-item>
                        </v-window>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <v-card class="default_card_wm elevation-0 rounded-l-2 rounded-r-0 fill-height">
                    <v-card-text>
                        <v-row no-gutters class="ma-1">
                            <v-col cols="12">
                                <v-list single-line class="pt-0" density="compact">
                                    <v-list-item
                                        :ripple="false"
                                        class="mb-2"
                                        color="success"
                                        @click="userDialog = true"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Collaborateur</b>
                                                </v-col>
                                                <v-col
                                                    cols="9"
                                                    class="d-flex align-center pl-2 justify-space-between"
                                                >
                                                    <div>
                                                        {{ getUserDisplayName(currentAccountUser) }}
                                                    </div>
                                                    <v-icon size="small">$oss-edit</v-icon>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                </v-list>
                                <oss-dialog
                                    v-model="userDialog"
                                    :fullscreen="$vuetify.display.mobile"
                                    :title="'Choissez une personne'"
                                    v-if="userDialog"
                                    @valid="userDialog = false"
                                    :validDisabled="!currentAccountUser || !currentAccountUser.id"
                                    :validLoading="validLoading"
                                    width="800px"
                                >
                                    <SelectUser
                                        v-model="currentAccountUser"
                                        :companyId="companyId"
                                    />
                                </oss-dialog>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="ma-1" v-if="form['date']">
                            <v-col cols="12" class="d-flex" style="flex-wrap: nowrap">
                                <div class="flex-grow-1">
                                    <oss-date-picker
                                        :hide-details="true"
                                        :label="$t('shared.date')"
                                        @update:model-value="
                                            onDateChange(form['date'], 'date', $event)
                                        "
                                        @mouseover="highlightField(form.date, true)"
                                        @mouseout="highlightField(form.date, false)"
                                        :mandatory="false"
                                        :textFieldReadOnly="false"
                                        :prefixDataCy="'DocumentValidationPaySlip-date-'"
                                        :model-value="formatDate(form['date'].value)"
                                    />
                                </div>
                                <div class="d-flex flex-grow-0 flex-shrink-1">
                                    <v-btn
                                        :color="
                                            form.date && form.date.validated ? 'primary' : 'red'
                                        "
                                        @click="validateDateField(form.date, 'date')"
                                    >
                                        <v-icon size="small">
                                            {{
                                                form.date && form.date.validated
                                                    ? "$oss-circle-check"
                                                    : "$oss-circle-uncheck"
                                            }}
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider class="my-2" />
                        <v-row no-gutters>
                            <v-col>
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'grossSalary')"
                                    @mouseover="highlightField(form.grossSalary, true)"
                                    @mouseout="highlightField(form.grossSalary, false)"
                                    :append-outer-icon="
                                        form.grossSalary.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.grossSalary.validated = !form['grossSalary'].validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.grossSalary.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.grossSalary") }}
                                        <span v-if="confidence(form.grossSalary)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.grossSalary) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.grossSalary)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="6">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'salaryCharges')"
                                    @mouseover="highlightField(form.salaryCharges, true)"
                                    @mouseout="highlightField(form.salaryCharges, false)"
                                    :append-outer-icon="
                                        form.salaryCharges.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.salaryCharges.validated = !form.salaryCharges.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.salaryCharges.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.salaryCharges") }}
                                        <span v-if="confidence(form.salaryCharges)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.salaryCharges) > 80
                                                        ? ''
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.salaryCharges)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'employerCharges')"
                                    @mouseover="highlightField(form.employerCharges, true)"
                                    @mouseout="highlightField(form.employerCharges, false)"
                                    :append-outer-icon="
                                        form.employerCharges.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.employerCharges.validated =
                                            !form.employerCharges.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.employerCharges.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.employerCharges") }}
                                        <span v-if="confidence(form.employerCharges)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.employerCharges) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.employerCharges)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="6">
                                <oss-text-field
                                    @update:model-value="
                                        onMetadataChange(form, 'nonDeductibleCSGCRDS')
                                    "
                                    @mouseover="highlightField(form.nonDeductibleCSGCRDS, true)"
                                    @mouseout="highlightField(form.nonDeductibleCSGCRDS, false)"
                                    :append-outer-icon="
                                        form.nonDeductibleCSGCRDS.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.nonDeductibleCSGCRDS.validated =
                                            !form.nonDeductibleCSGCRDS.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.nonDeductibleCSGCRDS.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.nonDeductibleCSGCRDS") }}
                                        <span v-if="confidence(form.nonDeductibleCSGCRDS)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.nonDeductibleCSGCRDS) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{
                                                    `${confidence(form.nonDeductibleCSGCRDS)}%`
                                                }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'hshc')"
                                    @mouseover="highlightField(form.hshc, true)"
                                    @mouseout="highlightField(form.hshc, false)"
                                    :append-outer-icon="
                                        form.hshc.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="form.hshc.validated = !form.hshc.validated"
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.hshc.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.hshc") }}
                                        <span v-if="confidence(form.hshc)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.hshc) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.hshc)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="4">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'navigo')"
                                    @mouseover="highlightField(form.navigo, true)"
                                    @mouseout="highlightField(form.navigo, false)"
                                    :append-outer-icon="
                                        form.navigo.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.navigo.validated = !form.navigo.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.navigo.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.navigo") }}
                                        <span v-if="confidence(form.navigo)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.navigo) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.navigo)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'benefitInKind')"
                                    @mouseover="highlightField(form.benefitInKind, true)"
                                    @mouseout="highlightField(form.benefitInKind, false)"
                                    :append-outer-icon="
                                        form.benefitInKind.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.benefitInKind.validated = !form.benefitInKind.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.benefitInKind.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.benefitInKind") }}
                                        <span v-if="confidence(form.benefitInKind)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.benefitInKind) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.benefitInKind)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'luncheonVoucher')"
                                    @mouseover="highlightField(form.luncheonVoucher, true)"
                                    @mouseout="highlightField(form.luncheonVoucher, false)"
                                    :append-outer-icon="
                                        form.luncheonVoucher.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.luncheonVoucher.validated =
                                            !form.luncheonVoucher.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.luncheonVoucher.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.luncheonVoucher") }}
                                        <span v-if="confidence(form.luncheonVoucher)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.luncheonVoucher) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.luncheonVoucher)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="6">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'employerLoan')"
                                    @mouseover="highlightField(form.employerLoan, true)"
                                    @mouseout="highlightField(form.employerLoan, false)"
                                    :append-outer-icon="
                                        form.employerLoan.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.employerLoan.validated = !form.employerLoan.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.employerLoan.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.employerLoan") }}
                                        <span v-if="confidence(form.employerLoan)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.employerLoan) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.employerLoan)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <oss-text-field
                                    @update:model-value="
                                        onMetadataChange(form, 'thirdPartyNotification')
                                    "
                                    @mouseover="highlightField(form.thirdPartyNotification, true)"
                                    @mouseout="highlightField(form.thirdPartyNotification, false)"
                                    :append-outer-icon="
                                        form.thirdPartyNotification.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.thirdPartyNotification.validated =
                                            !form.thirdPartyNotification.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.thirdPartyNotification.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.thirdPartyNotification") }}
                                        <span v-if="confidence(form.thirdPartyNotification)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.thirdPartyNotification) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{
                                                    `${confidence(form.thirdPartyNotification)}%`
                                                }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <oss-text-field
                                    @update:model-value="
                                        onMetadataChange(form, 'netSalaryBeforeTax')
                                    "
                                    @mouseover="highlightField(form.netSalaryBeforeTax, true)"
                                    @mouseout="highlightField(form.netSalaryBeforeTax, false)"
                                    :append-outer-icon="
                                        form.netSalaryBeforeTax.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.netSalaryBeforeTax.validated =
                                            !form.netSalaryBeforeTax.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.netSalaryBeforeTax.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.netSalaryBeforeTax") }}
                                        <span v-if="confidence(form.netSalaryBeforeTax)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.netSalaryBeforeTax) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{
                                                    `${confidence(form.netSalaryBeforeTax)}%`
                                                }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'incomeTax')"
                                    @mouseover="highlightField(form.incomeTax, true)"
                                    @mouseout="highlightField(form.incomeTax, false)"
                                    :append-outer-icon="
                                        form.incomeTax.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.incomeTax.validated = !form.incomeTax.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.incomeTax.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.incomeTax") }}
                                        <span v-if="confidence(form.incomeTax)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.incomeTax) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.incomeTax)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'netSalaryPaid')"
                                    @mouseover="highlightField(form.netSalaryPaid, true)"
                                    @mouseout="highlightField(form.netSalaryPaid, false)"
                                    :append-outer-icon="
                                        form.netSalaryPaid.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.netSalaryPaid.validated = !form.netSalaryPaid.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.netSalaryPaid.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.netSalaryPaid") }}
                                        <span v-if="confidence(form.netSalaryPaid)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.netSalaryPaid) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.netSalaryPaid)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <oss-text-field
                                    @update:model-value="onMetadataChange(form, 'totalCost')"
                                    @mouseover="highlightField(form.totalCost, true)"
                                    @mouseout="highlightField(form.totalCost, false)"
                                    :append-outer-icon="
                                        form.totalCost.validated
                                            ? '$check_box'
                                            : '$check_box_outline_blank'
                                    "
                                    @click:append-outer="
                                        form.totalCost.validated = !form.totalCost.validated
                                    "
                                    v-bind="ossTextFieldCommonBind"
                                    v-model="form.totalCost.value"
                                >
                                    <template #label>
                                        {{ $t("document.social.totalCost") }}
                                        <span v-if="confidence(form.totalCost)">
                                            (
                                            <span
                                                :class="
                                                    confidence(form.totalCost) > 80
                                                        ? 'text-green'
                                                        : 'text-red'
                                                "
                                                >{{ `${confidence(form.totalCost)}%` }}</span
                                            >)
                                        </span>
                                    </template>
                                </oss-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="ma-1">
                        <v-spacer />
                        <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    class="btn"
                                    rounded="circle"
                                    size="x-small"
                                    dark
                                    color="primary"
                                    @click="setOpenChat('INFORMATION_REQUEST')"
                                    v-bind="props"
                                    icon="$fa-comments"
                                >
                                </v-btn>
                            </template>
                            <span>Question</span>
                        </v-tooltip>
                        <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    class="btn"
                                    rounded="circle"
                                    @click="setOpenChat('DENIED')"
                                    size="x-small"
                                    v-bind="props"
                                    icon="report_problem"
                                >
                                </v-btn>
                            </template>
                            <span>Rejeter</span>
                        </v-tooltip>
                        <v-tooltip v-if="activateReconciliation" location="top">
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    class="btn"
                                    rounded="circle"
                                    size="x-small"
                                    dark
                                    color="primary"
                                    @click="openReconciliation()"
                                    v-bind="props"
                                    icon="$compare_arrows"
                                >
                                </v-btn>
                            </template>
                            <span>Rapprochement</span>
                        </v-tooltip>
                        <DocumentValidationSpeedRun
                            v-if="displayDocumentValidationSpeedRun(document.status)"
                            v-model="lastDocumentValidationDone"
                        />
                        <v-btn
                            class="btn"
                            rounded
                            :disabled="disabledValidate"
                            @click="onFormValidation()"
                            size="small"
                        >
                            {{ validated ? "Validé" : "Valider" }}
                            <v-icon v-show="validated">$check</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Chat
            v-if="openChat"
            v-bind:id="document.chat ? document.chat.id : ''"
            v-bind:inShowMessage="open_chat"
            v-bind:chatTitle="'Document'"
            v-bind:chatSubtitle="getChatSubTitle()"
            :showSmartChat="wishStatus !== 'DENIED'"
            @messageSent="onMessageSent($event)"
            @showMessageChanged="onShowMessageChanged($event)"
        />

        <oss-dialog v-model="dialogChooseDownload" title="Télécharger le document" width="80vw">
            Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté).

            <template v-slot:actions>
                <v-row no-gutters>
                    <v-col cols="6" class="pr-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(true);
                            "
                            size="x-large"
                            >Original</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(false);
                            "
                            size="x-large"
                            >Marqué</v-btn-primary
                        >
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
        <oss-dialog
            v-model="analyseDocumentDialog"
            title="Relancer l'analyse du document"
            @valid="analyseDocument"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir relancer l'analyse ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { DocumentValidationPaySlipBase } from "./DocumentValidationPaySlipBase";
import DocumentFileViewer from "@/components/document/FileViewer.vue";
import DocumentDropDown from "@/components/document/DropDown.vue";
import SelectUser from "../user/SelectUser.vue";

import AccountingItemStatic from "../AccountingItemStatic.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import DocumentValidationSpeedRun from "./DocumentValidationSpeedRun.vue";
import { isNoValidatedDocument } from "./DocumentValidationSpeedRun.helper";
import { Component, toNative } from "vue-facing-decorator";

@Component({
    components: {
        DocumentDropDown,
        DocumentFileViewer,
        AccountingItemStatic,
        UsersActivitiesHistory,
        SelectUser,
        DocumentValidationSpeedRun,
    },
})
export class DocumentValidationPaySlip extends DocumentValidationPaySlipBase {
    userDialog = false;
    validLoading = false;

    beforeMount() {
        this.svgSuffix = "document-validation-payslip";
    }

    get ossTextFieldCommonBind() {
        return {
            type: "number",
            rules: [this.isBalanced || ""],
            color: this.isBalanced ? "primary" : "red",
            success: this.isBalanced,
            error: !this.isBalanced,
            regular: true,
            outlined: true,
            dark: false,
            hideDetails: true,
            contentClass: "ma-1 oss-",
        };
    }

    displayDocumentValidationSpeedRun(documentStatus: string) {
        return isNoValidatedDocument(documentStatus);
    }
}

export default toNative(DocumentValidationPaySlip);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
